import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'
import {Text, Flex, Image} from '@chakra-ui/react'
import Hourglass from '@assets/svgs/exam/hourglass.svg'

interface ICountdownTimer {
  initialTime: number
  textStyle?: any
  onTimeEnded?: () => void
}

const CountdownTimer = (
  {initialTime, textStyle, onTimeEnded}: ICountdownTimer,
  ref: any,
) => {
  const [time, setTime] = useState(initialTime)
  const intervalRef: any = useRef(null)

  useImperativeHandle(
    ref,
    () => ({
      startTimer: () => startTimer(),
      pauseTimer: () => pauseTimer(),
    }),
    [],
  )

  useEffect(() => {
    return () => clearInterval(intervalRef.current)
  }, [])

  useEffect(() => {
    if (time === 0 && onTimeEnded) {
      onTimeEnded()
    }
  }, [time])

  const startTimer = () => {
    if (intervalRef.current === null) {
      intervalRef.current = setInterval(() => {
        setTime(prevTime => {
          if (prevTime > 0) {
            return prevTime - 1
          } else {
            clearInterval(intervalRef.current)
            intervalRef.current = null
            return 0
          }
        })
      }, 1000)
    }
  }

  const pauseTimer = () => {
    clearInterval(intervalRef.current)
    intervalRef.current = null
  }

  const formatTime = (time: any) => {
    const minutes = Math.floor(time / 60)
      .toString()
      .padStart(2, '0')
    const seconds = (time % 60).toString().padStart(2, '0')
    return `${minutes}:${seconds}`
  }

  return (
    <Flex gap={'8px'} alignItems={'center'} justifyContent={'center'}>
      <Image src={Hourglass} />
      <Text style={textStyle} color={'#1F1F1F'} fontSize={'24px'}>
        {formatTime(time)}
      </Text>
    </Flex>
  )
}

export default forwardRef(CountdownTimer)
